<template>
  <div v-loading="loading">
    <template v-if="[1, 3].includes(nodeData.state)">
      <p>
        {{ nodeTitleObj[routeInfo.name] }}：
        <span :class="'state-' + nodeData.paper.admin_state">
          {{ tutorState[nodeData.paper.admin_state] }}
        </span>
      </p>
      <el-descriptions v-if="[1].includes(nodeData.state)" direction="vertical" :column="6" border>
        <el-descriptions-item label="论文题目">
          <template v-if="nodeData?.paper?.title">{{ nodeData?.paper?.title }}</template>
          <!-- 空p标签用作占位 -->
          <p v-else></p>
        </el-descriptions-item>
        <el-descriptions-item label="研究方向">{{ nodeData?.paper?.directionName }}</el-descriptions-item>
        <el-descriptions-item label="组号">{{ nodeData?.paper?.extra_content?.group_name }}</el-descriptions-item>
        <el-descriptions-item label="汇报日期">{{ nodeData?.paper?.extra_content?.date }}</el-descriptions-item>
        <el-descriptions-item label="汇报会时间">{{ nodeData?.paper?.extra_content?.time }}</el-descriptions-item>
        <el-descriptions-item label="汇报会地点">{{ nodeData?.paper?.extra_content?.address }}</el-descriptions-item>
      </el-descriptions>
      <empty-component v-else :text="stateText"></empty-component>
    </template>
    <empty-component v-else :text="stateText"></empty-component>
  </div>
</template>

<script setup>
import API from '@/api'
import EmptyComponent from '../components/EmptyComponent.vue'
import Router from '@/router'
import { onMounted, ref, computed } from 'vue'

const props = defineProps({
  // 子节点的属性名
  childNode: {
    type: String,
    default: ''
  }
})

// 子节点名
const nodeName = computed(() => {
  return props.childNode
})

const routeInfo = ref(Router.currentRoute)

const loading = ref(false)

const nodeTitleObj = {
  opening_defense: '开题答辩结果',
  end_draft: '预答辩结果',
  draft_result: '评阅稿结果',
  paper_defense: '正式答辩结果'
}
const tutorState = {
  0: '未审核',
  1: '通过',
  2: '不通过'
}

const stateText = ref('')

const nodeData = ref('')
// 获取其他节点数据
function getNodeInfo() {
  loading.value = true
  API.MBAThesisProcessInfo({ node: routeInfo.value.name, children: nodeName.value }).then(res => {
    if (+res.code === 200) {
      nodeData.value = res.data
      stateText.value = res.data.stateText
    }
    loading.value = false
  }).catch((err) => {
    loading.value = false
    console.error(err.msg)
  })
}
onMounted(() => {
  getNodeInfo()
})
</script>

<style lang="scss" scoped>
.state {

  &-1 {
    color: #67C23A;
  }

  &-2 {
    color: #F56C6C;
  }

}
</style>
